// Import ScrollReveal

import ScrollReveal from 'scrollreveal';

// Initialize ScrollReveal
document.addEventListener('DOMContentLoaded', function () {
    // Check if the viewport width is greater than or equal to 992 pixels (desktop view)
    if (window.innerWidth >= 992) {
        // Define options for ScrollReveal
        const options = {
            duration: 1000,
            distance: '50px',
            easing: 'ease-in-out',
            reset: false,
            scale: 0.85, 
            delay: 100, 
        };

        // Target each splide__slide and apply the stagger effect
        document.querySelectorAll('.splide__slide').forEach((slide, index) => {
            ScrollReveal().reveal(slide, { ...options, delay: 100 * index });
        });
        document.querySelectorAll('.offers-wrapper').forEach((wrapper, index) => {
            ScrollReveal().reveal(wrapper, { ...options, delay: 100 * index });
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    ScrollReveal().reveal('.about-our-family .image-wrapper', {
        duration: 900,
        distance: '50px',
        easing: 'ease-in-out',
        reset: false,
        scale: 0.85, 
        delay: 100, 
    });
});

document.addEventListener('DOMContentLoaded', function () {
    ScrollReveal().reveal('.wp-block-image', {
        duration: 900,
        distance: '50px',
        easing: 'ease-in-out',
        reset: false,
        scale: 0.85, 
        delay: 100, 
    });
});